import { useState } from "react";
import { uploadBusinessDocumentV4 } from "../../pages/Compliance/complianceAPI";

export const useFileUpload = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const uploadFile = async (
    file: File,
    businessId: number | string,
    businessDocumentId: number | string,
  ) => {
    setUploading(true);
    setError(null);
    try {
      return await uploadBusinessDocumentV4({ businessId, businessDocumentId, file });
    } catch (error) {
      setError("Upload failed. Please try again.");
      throw error;
    } finally {
      setUploading(false);
    }
  };

  return { file, setFile, uploading, error, uploadFile };
};
